import { Box, Button, Fade, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Loading } from "../../common/components";
import { getEquiposActivos, getEquiposInactivos } from "../../helpers/equipos";

export const Equipos = () => {
  // Nombre de la página
  document.title = "Equipos";

  const [loading, setLoading] = useState(true);
  const [equiposActivos, setEquiposActivos] = useState([]);
  const [equiposInactivos, setEquiposInactivos] = useState([]);

  const columnasEA = [
    { field: "nombre", headerName: "Nombre", width: 270 },
    { field: "capitan", headerName: "Capitán", width: 270 },
    {
      field: "num_acolitos",
      headerName: "Número de integrantes",
      width: 190,
    },
    { field: "fecha_comienzo", headerName: "Fecha de creación", width: 180 },
    // Botón para editar el equipo
    {
      field: "editar",
      headerName: "Editar equipo",
      width: 150,
      renderCell: (params) => {
        return (
          <Button
            color="primary"
            onClick={() => {
              window.location.href = `/equipos/${params.row.id}`;
            }}
          >
            Editar
          </Button>
        );
      },
    },
  ];

  const columnasEI = [
    { field: "nombre", headerName: "Nombre", width: 270 },
    { field: "capitan", headerName: "Capitán", width: 270 },
    { field: "fecha_comienzo", headerName: "Fecha de creación", width: 180 },
    { field: "fecha_termino", headerName: "Fecha de finalización", width: 180 },
  ];

  const getData = async () => {
    const ea = await getEquiposActivos();

    if (ea) {
      setEquiposActivos(ea);
    }
    const ei = await getEquiposInactivos();
    if (ei) {
      setEquiposInactivos(ei);
    }
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []); // Se reejecuta cuando cambia la clave de la ubicación

  if (loading) {
    return <Loading texto="Obteniendo información" />;
  }

  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Typography
          id="transition-modal-title"
          variant="h4"
          sx={style.modal_title}
          color="primary"
          fontWeight={900}
        >
          EQUIPOS ACTIVOS
        </Typography>
        <Box
          sx={{
            padding: 3,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "80%",
            margin: "auto",
            marginTop: 5,
            marginBottom: 5,
          }}
        >
          <DataGrid
            rows={equiposActivos}
            columns={columnasEA}
            slots={{
              toolbar: GridToolbar,
            }}
            loading={loading}
            // onRowClick={(row) => {
            //   window.location.href = `/acolitos/${row.row.id}`;
            // }}
          />
        </Box>
        <Typography
          id="transition-modal-title"
          variant="h4"
          sx={style.modal_title}
          color="primary"
          fontWeight={900}
        >
          HISTORIAL DE EQUIPOS INACTIVOS
        </Typography>
        <Box
          sx={{
            padding: 3,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "80%",
            margin: "auto",
            marginTop: 5,
            marginBottom: 5,
          }}
        >
          <DataGrid
            rows={equiposInactivos}
            columns={columnasEI}
            slots={{
              toolbar: GridToolbar,
            }}
            loading={loading}
            key={equiposInactivos.id}
          />
        </Box>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
  },
};
